<template>
  <div>
    <div
      v-if="userData.role != 'author'"
      class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8"
    >
      <editModal
        :editModal="editModal"
        :selectedCourse="selectedCourse"
        @close-modal="toggleEditModal"
      />

      <b-card
        no-body
        v-for="(item, index) in course.result"
        :key="'item -' + index"
        class="custp0 cursor-pointer"
        @click="handleClick('course', item)"
      >
        <div class="mb-2">
          <div>
            <img
              :src="$imageURL + '/' + item.icone"
              class="rounded-t-lg img-ht-user"
            />
          </div>

          <div class="w-full px-4 pt-4">
            <div class="">
              <div class="flex justify-between items-baseline">
                <div class="flex">
                  <h3 class="font-bold text-base specialcourse ellipsis-2">
                    {{ item.name }}
                  </h3>
                </div>
              </div>

              <div class="pt-3 pb-1">
                <div class="flex items-center">
                  <div class="flex items-center">
                    <feather-icon
                      class="icon-w13 mr-2"
                      icon="ClockIcon"
                      svgClasses="w-5 h-5"
                    ></feather-icon>
                    <p class="text-primary font-semibold text-sm">Duration</p>
                  </div>
                  <p class="pl-2 text-sm">{{ item.duration }} hrs</p>
                </div>

                <div class="flex items-center mt-1">
                  <div class="flex items-center">
                    <feather-icon
                      class="icon-w13 mr-2"
                      icon="AwardIcon"
                      svgClasses="w-5 h-5"
                    ></feather-icon>
                    <p class="text-primary font-semibold text-sm">Author</p>
                  </div>
                  <!-- <p>data.userId.firstname + " " + data.userId.lastname</p> -->
                  <p class="text-sm pl-2">
                    {{
                      item.author
                        .map((data) => {
                          let name = " ";
                          if (data.userId && data.userId.firstname) {
                            name += data.userId.firstname + " ";
                          }
                          if (data.userId && data.userId.lastname) {
                            name += data.userId.lastname;
                          }
                          return name;
                        })
                        .toString()
                    }}
                  </p>
                </div>
              </div>
            </div>
            <p class="text-sm mt-2 ellipsis-3 spcoursedescrip">
              {{ item.description }}
            </p>

            <b-divider class="cust-divider my-8" />
            <b-badge pill variant="success" class="text-xs mt-1"
              >Approved</b-badge
            >

            <div class="pt-2 flex justify-between items-center">
              <!-- <div class="star-ratingteam15 pt-1 mr-4"></div> -->

              <p class="font-bold text-lg mr-2">₹ {{ item.discountPrice }}</p>
              <span
                class="font-weight-light line-through mr-auto text-base"
                v-if="item.price != item.discountPrice"
                >₹ {{ item.price }}</span
              >

              <div class="flex">
                <div>
                  <vs-button
                    icon
                    aria-label="upload"
                    class="bg-rounded-success-l cust-roundedfull p-11px iconcourse cursor-pointer"
                    color="success"
                    v-b-modal="'editModal'"
                    @click.stop="editCourse(item)"
                  >
                    <div class="">
                      <feather-icon
                        icon="EditIcon"
                        class="text-success m-auto"
                      />
                    </div>
                  </vs-button>
                  <div>
                    <input ref="imageInput" type="file" class="hidden" />
                  </div>
                </div>
                <div class="mr-2">
                  <base-button
                    icon
                    aria-label="delete"
                    class="bg-rounded-danger-l cust-roundedfull p-11px iconcourse cursor-pointer"
                    type="danger"
                    @click.stop="deleteCourse(item)"
                  >
                    <div class="">
                      <feather-icon
                        icon="Trash2Icon"
                        class="text-danger m-auto"
                      />
                    </div>
                  </base-button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex mt-4 justify-between px-2 items-center mb-4">
            <base-button
              class="font-semibold text-xs iconplustext flex w-full mr-2 cust-br5 h-8 cust-orange border-none"
              size="small"
              color=""
              @click.stop="handleClick('admin-coursecustomizedetails', item)"
            >
              <feather-icon
                class="cursor-pointer w-2 mr-4 text-white"
                icon="CommandIcon"
                svgClasses="w-4 mr-4"
              ></feather-icon>
              <p class="text-xs">Customize</p>
            </base-button>
            <base-button
              class="font-semibold text-xs iconplustext flex w-1/2 mr-2 cust-br5 h-8 cust-primary border-none"
              size="small"
              color=""
              @click.stop="handleAttendees('admin-Attendees', item)"
            >
              <feather-icon
                class="cursor-pointer w-2 mr-4"
                icon="UsersIcon"
                svgClasses="w-4 mr-4"
              ></feather-icon>
              <p class="text-sm">Attendees</p>
            </base-button>
          </div>

          <!-- <div class="mb-2 px-2 mr-2">
          <base-button
            class="font-semibold  text-xs iconplustext w-full mr-2 cust-br5 h-8  border-none"
            size="small"
            blocked
            type="default"
            v-b-modal="'editModal'"
            @click="editCourse(item)"
          >
            <feather-icon
              class=" cursor-pointer w-2 mr-4 text-white"
              icon="EditIcon"
              svgClasses="w-4 mr-4"
            ></feather-icon>
            <p class="text-xs">Edit</p>
          </base-button>
        </div> -->
          <!-- <div class="px-2 mr-2">
          <base-button
            class="font-semibold  text-xs iconplustext w-full  mr-2 cust-br5 h-8  border-none"
            size="small"
            blocked
            type="danger"
            @click="deleteCourse(item)"
          >
            <feather-icon
              class=" cursor-pointer w-2 mr-4 text-white"
              icon="Trash2Icon"
              svgClasses="w-4 mr-4"
            ></feather-icon>
            <p class="text-xs">Delete</p>
          </base-button>
        </div> -->
        </div>
      </b-card>
    </div>
    <div
      v-else
      class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8"
    >
      <editModal
        :editModal="editModal"
        :selectedCourse="selectedCourse"
        @close-modal="toggleEditModal"
      />
      <b-card
        no-body
        v-for="(item, index) in authorData[0].courses"
        :key="'item -' + index"
        class="custp0 cursor-pointer"
        @click="handleClick('course', item)"
      >
        <div class="mb-2">
          <div>
            <img
              :src="$imageURL + '/' + item.icone"
              class="rounded-t-lg img-ht-user"
            />
          </div>

          <div class="w-full px-4 pt-4">
            <div class="">
              <div class="flex justify-between items-baseline">
                <div class="flex">
                  <h3 class="font-bold text-base specialcourse ellipsis-2">
                    {{ item.name }}
                  </h3>
                </div>
              </div>

              <div class="pt-3 pb-1">
                <div class="flex items-center">
                  <div class="flex items-center">
                    <feather-icon
                      class="icon-w13 mr-2"
                      icon="ClockIcon"
                      svgClasses="w-5 h-5"
                    ></feather-icon>
                    <p class="text-primary font-semibold text-sm">Duration</p>
                  </div>
                  <p class="pl-2 text-sm">
                    {{ item.duration }}
                  </p>
                </div>

                <div class="flex items-center mt-1">
                  <div class="flex items-center">
                    <feather-icon
                      class="icon-w13 mr-2"
                      icon="AwardIcon"
                      svgClasses="w-5 h-5"
                    ></feather-icon>
                    <p class="text-primary font-semibold text-sm">Author</p>
                  </div>
                  <p class="text-sm pl-2">
                    {{
                      userData.firstname
                        ? userData.firstname
                        : "" + " " + userData.lastname
                        ? userData.lastname
                        : ""
                    }}
                  </p>
                </div>
              </div>
            </div>
            <p class="text-sm mt-2 ellipsis-3 spcoursedescrip">
              {{ item.description }}
            </p>

            <b-divider class="cust-divider my-8" />
            <b-badge pill variant="success" class="text-xs mt-1"
              >Approved</b-badge
            >

            <div class="pt-2 flex justify-between items-center">
              <!-- <div class="star-ratingteam15 pt-1 mr-4"></div> -->

              <p class="font-bold text-lg mr-2">₹ {{ item.discountPrice }}</p>
              <span
                class="font-weight-light line-through mr-auto text-base"
                v-if="item.price != item.discountPrice"
                >₹ {{ item.price }}</span
              >

              <div class="flex">
                <div>
                  <base-button
                    icon
                    aria-label="upload"
                    class="bg-rounded-success-l cust-roundedfull p-11px iconcourse cursor-pointer"
                    type="success"
                    v-b-modal="'editModal'"
                    @click.stop="editCourse(item)"
                  >
                    <span class=""
                      ><i class="fas fa-pen fsize12 text-success"></i
                    ></span>
                  </base-button>
                  <div>
                    <input ref="imageInput" type="file" class="hidden" />
                  </div>
                </div>
                <div class="mr-2">
                  <base-button
                    icon
                    aria-label="delete"
                    class="bg-rounded-danger-l cust-roundedfull p-11px iconcourse cursor-pointer"
                    type="danger"
                    @click.stop="deleteCourse(item)"
                  >
                    <span class=""
                      ><i class="far fa-trash-alt fsize12 text-danger"></i
                    ></span>
                  </base-button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex mt-4 justify-between px-2 items-center mb-4">
            <base-button
              class="font-semibold text-xs iconplustext flex w-full mr-2 cust-br5 h-8 cust-orange border-none"
              size="small"
              color=""
              @click.stop="handleClick('admin-coursecustomizedetails', item)"
            >
              <feather-icon
                class="cursor-pointer w-2 mr-4 text-white"
                icon="CommandIcon"
                svgClasses="w-4 mr-4"
              ></feather-icon>
              <p class="text-xs">Customize</p>
            </base-button>
            <base-button
              class="font-semibold text-xs iconplustext flex w-1/2 mr-2 cust-br5 h-8 cust-primary border-none"
              size="small"
              color=""
              @click.stop="handleAttendees('admin-Attendees', item)"
            >
              <feather-icon
                class="cursor-pointer w-2 mr-4"
                icon="UsersIcon"
                svgClasses="w-4 mr-4"
              ></feather-icon>
              <p class="text-sm">Attendees</p>
            </base-button>
          </div>

          <!-- <div class="mb-2 px-2 mr-2">
          <base-button
            class="font-semibold  text-xs iconplustext w-full mr-2 cust-br5 h-8  border-none"
            size="small"
            blocked
            type="default"
            v-b-modal="'editModal'"
            @click="editCourse(item)"
          >
            <feather-icon
              class=" cursor-pointer w-2 mr-4 text-white"
              icon="EditIcon"
              svgClasses="w-4 mr-4"
            ></feather-icon>
            <p class="text-xs">Edit</p>
          </base-button>
        </div> -->
          <!-- <div class="px-2 mr-2">
          <base-button
            class="font-semibold  text-xs iconplustext w-full  mr-2 cust-br5 h-8  border-none"
            size="small"
            blocked
            type="danger"
            @click="deleteCourse(item)"
          >
            <feather-icon
              class=" cursor-pointer w-2 mr-4 text-white"
              icon="Trash2Icon"
              svgClasses="w-4 mr-4"
            ></feather-icon>
            <p class="text-xs">Delete</p>
          </base-button>
        </div> -->
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import editModal from "./EditModal.vue";
import Customize from "./Customize.vue";
import "../../../scss/Index.scss";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showCustomize: false,
      Answers: ["", ""],
      // course: [],
      name: "",
      description: "",
      content: "",
      courseFor: "",
      duration: "",
      price: "",
      discountPrice: "",
      // category: "",
      selectedCourse: {},
      editModal: false,
      courseDetails: [
        {
          img: require("../img/care1.jpg"),
          title: " Ph.D in Commerce ",
          buttonText: "Active",
          author: "Mohnish Thandassery",
          price: "450",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
        },
        {
          img: require("../img/care1.jpg"),
          title: "Ph.D in Statistics",
          buttonText: "Active",
          author: "Sumit Jaiswal",
          price: "550",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
        },
        {
          img: require("../img/care1.jpg"),
          title: " Ph.D in Accountancy ",
          buttonText: "Active",
          author: "John Doe",
          price: "650",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
        },
      ],
    };
  },
  components: {
    Customize,
    editModal,
  },
  watch: {
    text(val) {
      this.$store.commit("posts/SET_POST", { key: "text", value: val });
    },
    Answers(val) {
      this.$store.commit("posts/SET_POST", { key: "Answers", value: val });
    },
  },
  methods: {
    handleClick(name, courseData) {
      this.$router.push({ name: name });
      this.$store.commit("eLearning/selectedCourse", courseData);
    },
    async handleAttendees(name, courseData) {
      this.$router.push({ name: name });
      this.$store.commit("eLearning/selectedCourse", courseData);
      const userId = [];
      courseData.attendees.map((x) => userId.push(x.createdBy._user));
      await this.$store.dispatch("learningTracker/getCourseByStudentId", {
        course: courseData._id,
        userId: userId,
      });
    },

    async getCourses() {
      if (this.userData.role == "author") {
        await this.$store.dispatch("author/getAuthorByUserId", {
          userId: this.userData._id,
        });
      } else {
        let payload = {
          limit: 10,
          offset: (1 - 1) * 10,
          isAdmin: true,
        };
        await this.$store.dispatch("eLearning/getCourses", payload);
      }
      // console.log(this.authorData);
    },

    AddNewAnswer(index) {
      if (this.Answers.length - 1 == index) {
        this.Answers.push("");
      }
    },
    DeleteAnswer(index) {
      if ([0, 1].includes(index)) {
        return;
      }
      this.Answers = this.Answers.filter((el, ind) => ind !== index);
    },
    deleteCourse(courseData) {
      const author_id = courseData.author.map((items) => {
        return items._id;
      });
      // console.log(author_id);
      this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value == true) {
          try {
            const loader = this.$loading();

            const { data } = this.$store.dispatch("eLearning/deleteCourse", {
              _id: courseData._id,
              author: author_id,
              category: courseData.category,
            });
            // this.$swal("Deleted!", "Your file has been deleted.", "success");
            this.$swal.fire({
              title: "Deleted",
              text: "Your file has been deleted.",
              icon: "success",
              confirmButtonColor: "#830c81",
            });
            loader.close();
            this.getCourses();
            this.getCourses();
          } catch (err) {
            loader.close();
          }
        }
      });
    },
    async toggleEditModal(val = false) {
      this.editModal = val;
      if (!val) {
        await this.getCourses();
      }
    },
    async editCourse(data) {
      this.toggleEditModal(true);
      this.selectedCourse = data;

      // this.getCourses();
    },
    // async saveChanges(name) {
    //   this.editModal = false;
    // },
    async saveChanges(name) {
      if (this.name.length != 0) {
        const { data } = await this.$store.dispatch("eLearning/editCourse", {
          name: this.name,
          _id: this.selectedCourse,
        });
        // console.log(this.data);
        // console.log(name);
        this.editModal = false;
      } else {
        // console.log("Please fill all Details");
      }
    },
    hideModal() {
      this.$refs["editModal"].hide();
    },
  },
  mounted() {
    this.getCourses();
  },
  computed: {
    ...mapState("eLearning", ["course"]),
    ...mapState("auth", ["userData"]),
    ...mapState("author", ["authorData"]),
  },
};
</script>
<style lang="scss" scoped>
.bg-rounded-success-l {
  background: rgba(40, 199, 111, 0.12) !important;
}
.p-11px {
  padding: 8px !important;
}
.cust-roundedfull {
  border-radius: 999px !important;
}
.bg-rounded-danger-l {
  background: rgba(234, 84, 85, 0.12) !important;
}
.btn-inner--icon {
  i:not(.fa) {
    position: relative;
    top: 1.5px;
  }
}
.fsize18 {
  font-size: 16px !important ;
}
.ellipsis-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.img-ht-user {
  height: 300px;
  object-fit: cover;
  width: 100%;
}
</style>
